// extracted by mini-css-extract-plugin
module.exports = {"udtitlesForm":"ParticipantUDTitle_udtitlesForm__ejwGf","submitButton":"ParticipantUDTitle_submitButton__21fgS"};